'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 300px;\n  height: 300px;\n  border-radius: 50%;\n  position: relative;\n  overflow: hidden;\n  pointer-events: none;\n  background: radial-gradient(ellipse at bottom, #4141ab 0%, #5353db 100%);\n  box-shadow: 4px 4px 40px 0px rgba(0, 0, 0, 0.2);\n  transform: ', ';\n  ', ';\n'], ['\n  width: 300px;\n  height: 300px;\n  border-radius: 50%;\n  position: relative;\n  overflow: hidden;\n  pointer-events: none;\n  background: radial-gradient(ellipse at bottom, #4141ab 0%, #5353db 100%);\n  box-shadow: 4px 4px 40px 0px rgba(0, 0, 0, 0.2);\n  transform: ', ';\n  ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Space = _styledComponents2.default.div(_templateObject, function (_ref) {
  var visible = _ref.visible;
  return visible ? 'none' : 'translateY(50px)';
}, (0, _polished.transitions)('transform .3s ease-in-out'));

exports.default = Space;